import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { HirePage } from '../../../../features/hr/hire-page'

export const Route = createFileRoute('/_app/hr/employees/new')({
  staticData: { crumb: 'hrEmployeeNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'employees.hire'),
  component: HirePage,
})
